/*
 * Tiny IDB-backed draft store for the bottom-input textarea. Per-scene + per-batch.
 * See IMPLEMENTATION_PLAN.md §4 "Saving — robustness model" → "Drafts".
 */

import { openDB, type IDBPDatabase } from 'idb';

const DB_NAME = 'studio-v2-drafts';
const DB_VERSION = 1;
const STORE = 'drafts';

let dbPromise: Promise<IDBPDatabase> | null = null;

function db(): Promise<IDBPDatabase> {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(database) {
        if (!database.objectStoreNames.contains(STORE)) {
          database.createObjectStore(STORE);
        }
      },
    });
  }
  return dbPromise;
}

export async function readDraft(key: string): Promise<string | null> {
  const database = await db();
  const value = await database.get(STORE, key);
  return typeof value === 'string' ? value : null;
}

export async function writeDraft(key: string, value: string): Promise<void> {
  const database = await db();
  if (!value) {
    await database.delete(STORE, key);
    return;
  }
  await database.put(STORE, value, key);
}

export function draftKey(episodeUuid: string, kind: 'scene' | 'batch', sceneId?: string): string {
  if (kind === 'batch') return `${episodeUuid}:batch`;
  return `${episodeUuid}:scene:${sceneId ?? 'none'}`;
}
